import script from "./PontotelSeletorInternacionalizado.vue?vue&type=script&lang=js"
export * from "./PontotelSeletorInternacionalizado.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__file',"src/common/selectors/PontotelSeletorInternacionalizado.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "632c6131"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('632c6131', __exports__)) {
    api.reload('632c6131', __exports__)
  }
  
}


export default __exports__